<script setup>
import {onMounted, ref, reactive} from "vue";
import router from "@/router/index.js";
import YTTablePagination from "@/components/YTTablePagination/YTTablePagination.vue";
import {listRole, removeRole} from "@/api/user/user.js";

/*初次加载*/
onMounted(() => {
  handleSearch()
})

/*搜索功能*/
// 表单数据
const formData = reactive({
  roleName: null,
});
// 根据表单搜索信息
const handleSearch = async (mode = 'init') => {
  if (mode === 'btnSearch') YTTablePaginationRef.value.resetPage()
  try {
    const param = ref({
      page: YTTablePaginationRef.value.getPage(),
      pageSize: YTTablePaginationRef.value.getPageSize()
    })
    loading.value = true;
    const res = await listRole(param.value, formData);
    tableData.value = []
    tableData.value = res.list
    total.value = parseInt(res.total)
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
// 清空表单内容
const handleReset = () => {
  formData.roleName = null
  handleSearch('btnSearch')
}

/*表格数据展示*/
// 翻页组件锚点
const YTTablePaginationRef = ref()
// 翻页信息：总条目数、加载状态
const total = ref(0)
const loading = ref(false)
const headers = ref([
  { title: '编号', key: 'roleId', minWidth: "120px", nowrap: true },
  { title: '角色名', key: 'roleName', minWidth: "120px", nowrap: true },
  { title: '系统类型', key: 'systemType', minWidth: "120px", nowrap: true },
  { title: '描述', key: 'roleDesc', minWidth: "200px", nowrap: true },
  { title: '创建时间', key: 'crTime', minWidth: "150px", nowrap: true },
  { title: '操作', key: 'controls', minWidth: "100px", fixed: true },
])
// 表格数据
const tableData = ref([])
// 翻页
const handleChangePage = () => {
  handleSearch()
}

/*操作栏功能*/
// 展示的详情信息
const detailInfo = ref()
// 获取详情信息
const getDetail = (info) => {
  detailInfo.value = info
  router.push({path: "/editSystemRole", query: {roleId: detailInfo.value.roleId}})
}

/*删除操作对话框*/
const dialogConfirm = async (item) => {
  try {
    loading.value = true
    await removeRole(item.roleId)
    loading.value = false
    await handleSearch()
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}

/*跳转增加*/
const handleAdd = () => {
  router.push("/editSystemRole")
}
</script>

<template>
  <div class="container_box mg_b_2" style="padding-bottom: 16px">
    <div class="flex_left" style="padding-left: 16px;">
      <v-btn color="success" @click="handleAdd" :disabled="!$handleHasBtnPermission('all', 'systemRole:add')">增加角色</v-btn>
    </div>
  </div>
  <div class="container_box">
    <v-row justify="center">
      <v-col cols="9">
        <v-data-table
            :headers="headers"
            :items="tableData"
            :loading="loading"
            :items-per-page="$globalPageSize"
            :no-data-text="'没有更多数据了~'"
            hover
        >
          <template v-slot:loading>
            <v-skeleton-loader type="table-row@1"></v-skeleton-loader>
          </template>

          <template v-slot:top>
            <v-form>
              <v-container>
                <v-row justify="center">
                  <v-col cols="4">
                    <v-text-field
                        v-model="formData.roleName"
                        placeholder="请输入角色名"
                        label="角色名"
                        variant="outlined"
                        clearable
                    ></v-text-field>
                  </v-col>
                  <v-col cols="3" offset="5">
                    <v-row justify="end">
                      <v-col class="flex_right" cols="6">
                        <v-btn color="success" size="large" @click="handleSearch('btnSearch')" :disabled="!$handleHasBtnPermission('all', 'systemRole:view')">搜索</v-btn>
                      </v-col>
                      <v-col class="flex_right" cols="6">
                        <v-btn size="large" @click="handleReset" :disabled="!$handleHasBtnPermission('all', 'systemRole:view')">重置</v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </template>

          <template v-slot:item.systemType="{ item }">
            <div v-if="item.systemType === 'OPERATION'">运营平台（公司内部使用）</div>
            <div v-else-if="item.systemType === 'MERCHANT'">商家平台</div>
            <div v-else>未知</div>
          </template>

          <template v-slot:item.controls="{ item }">
            <div class="flex_left">
              <el-tooltip
                  class="box-item"
                  effect="dark"
                  content="编辑"
                  placement="left">
                <v-icon icon="mdi-file-edit-outline" color="primary" size="small" @click="getDetail(item)" v-show="$handleHasBtnPermission('all', 'systemRole:edit') && !item.admin"></v-icon>
              </el-tooltip>
              <el-popconfirm @confirm="dialogConfirm(item)" :title="`确定删除角色 “${item.roleName}” 吗？`">
                <template #reference>
                  <div>
                    <el-tooltip
                        class="box-item"
                        effect="dark"
                        content="删除"
                        placement="right"
                        @click.stop>
                      <v-icon class="cursor-pointer" color="error" icon="mdi-close" v-show="$handleHasBtnPermission('all', 'systemRole:delete') && !item.admin"></v-icon>
                    </el-tooltip>
                  </div>
                </template>
                <template #actions="{ confirm, cancel }">
                  <div class="flex_bt">
                    <v-btn size="small" @click="cancel">取消</v-btn>
                    <v-btn size="small" color="primary" @click="confirm">确定</v-btn>
                  </div>
                </template>
              </el-popconfirm>
            </div>
          </template>

          <template v-slot:bottom>
            <YTTablePagination ref="YTTablePaginationRef" :total="total" @page-change="handleChangePage"></YTTablePagination>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<style scoped>

</style>
